module.exports = __webpack_public_path__ + "fa-solid-900.b093fcb2c86d52309e28.woff";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/assets/fonts/webfonts/fa-solid-900.woff
// module id = ../../../../../src/assets/fonts/webfonts/fa-solid-900.woff
// module chunks = styles